// src/types/pendingOrdersFormTypes.ts
// Tipos e interfaces para PendingOrdersForm

export interface OrderDetail {
  id: number
  orders_id: number
  origin_order_id: number
  store_name: string
  status: string
  total: string
  envio?: string
  guia?: string
  date_created: string
  date_modified: string
  agente?: number
  extraDetails?: {
    forma_pago?: string
    payment_method?: string
    transaction_id?: string
    customer_note?: string
    transportadora?: string
    cliente_neto?: boolean | string | number
  }
  transaction_id?: string
  customer: {
    first_name: string
    last_name: string
    email: string
    document?: string
    tipo_documento?: string
    tipo_persona?: string
  }
  billingAddress: {
    address_1: string
    address_2?: string
    city: string
    state: string
    country: string
    postcode: string
    phone?: string
  }
  shippingAddress: {
    address_1: string
    address_2?: string
    city: string
    state: string
    country: string
    postcode: string
    phone?: string
  }
  lineItems: Array<{
    product_id: string
    product_name: string
    quantity: number
    price: string
    is_combo?: number
    components?: Array<{
      id_combo?: number
      sku: string
      quantity: number
      name: string
      price: string
      tax_rate: string
      ean12?: string
      peso?: string | null
      longitud?: string | null
      ancho?: string | null
      alto?: string | null
      instrucciones_empaque?: string
      imagen?: string
    }>
  }>
}

export interface PendingOrderFormData {
  // Dirección de Origen
  origenNombre: string
  origenEmpresa?: string
  origenEmail?: string
  origenCelular: string
  origenPais: string
  origenDepartamento: string
  origenCiudad: string
  origenDireccion: string
  origenReferencia?: string
  origenNit?: string

  // Dirección de Destino
  destinoNombre: string
  destinoEmpresa?: string
  destinoEmail?: string
  destinoCelular: string
  destinoPais: string
  destinoDepartamento: string
  destinoCiudad: string
  destinoDireccion: string
  destinoDireccion_2: string
  destinoReferencia?: string
  destinoNit?: string

  // Información del paquete
  contenido: string
  largo: number
  ancho: number
  altura: number
  peso: number
  valorDeclarado?: number
  recaudoContraEntrega?: number
  texto_guia: string
  accion_notaguia: string
  centrocosto: string
  valorproducto: string
  valorFlete: number
  metodoPago: string
}

export interface PendingOrdersFormProps {
  orderDetail?: OrderDetail | null
  isLiquidateMode?: boolean
  hideDestinationFields?: string[]
  hidePackageFields?: string[]
  hideProductSection?: boolean
}

export interface TipoServicioLiquidacion {
  value: string
  label: string
  description: string
}

export const tiposDeServicioLiquidacion: TipoServicioLiquidacion[] = [
  { value: '12', label: 'Paquete Terrestre', description: 'Servicio terrestre para paquetes' },
  { value: '3', label: 'Mercancía Terrestre', description: 'Servicio terrestre para mercancía' }
]

